import { isAccessTokenValid } from './decode';
import type { SessionPhase } from '../sso/types';

/**
 * True when authenticated API calls may use the current access token.
 * Blocks during bootstrap refresh, session lock, and invalid/expired tokens.
 */
export const canMakeAuthenticatedRequests = ({
  ready,
  isRefreshing,
  sessionPhase,
  accessToken,
}: {
  ready: boolean;
  isRefreshing: boolean;
  sessionPhase: SessionPhase;
  accessToken: string | null;
}): boolean => {
  return (
    ready &&
    !isRefreshing &&
    sessionPhase === 'active' &&
    isAccessTokenValid(accessToken)
  );
};
